/***********************
 * GLOBAL FLAGS / GUARDS
 ***********************/
window.__suppressPfandSync = window.__suppressPfandSync || false; // if our own cart writes true
window.__pfandBusy         = window.__pfandBusy         || false; // re-entry guard
window.__pfandRefreshLock  = window.__pfandRefreshLock  || false; // one-time refresh consume
window.__pfandDebounceTS   = window.__pfandDebounceTS   || 0;     // optional debounce

/***********************
 * PFAND CONSTANTS + HELPERS
 ***********************/
const PFAND_VARIANT_ID = 55966268096777; // pfand product

// baseVariantId: pfand_multiplier (extend here)
const PFAND_MAP = {
  55952711287049: 2,
  55952711319817: 4,
  55952711057673: 1,
  55952711090441: 2,
  55952711123209: 4,
  55952711155977: 1,
  55952711188745: 2,
  55952711221513: 4
};

// helpers (moved up to avoid TDZ)
const getVarId = (i) => String(i?.variantId ?? i?.variant_id);
const getPfandMultiplierFor = (variantId) =>
  Number(PFAND_MAP[String(variantId)] || 0);

/******** Utils ********/
const sleep = (ms) => new Promise(r => setTimeout(r, ms));

let pfandInput = document.getElementById('pfand-property');
let pfandInputQuantity = document.getElementById('pfand-quantity');

/***********************
 * POLLER + HELPERS
 ***********************/
const pollerLite = (conditions, callback, maxTime = 10000000) => {
  const POLLING_INTERVAL = 25;
  const startTime = Date.now();
  const interval = setInterval(() => {
    const allConditionsMet = conditions.every((condition) => {
      if (typeof condition === 'function') {
        return condition();
      }
      return !!document.querySelector(condition);
    });
    if (allConditionsMet) {
      clearInterval(interval);
      callback();
    } else if (Date.now() - startTime >= maxTime) {
      clearInterval(interval);
      console.error('Polling exceeded maximum time limit');
    }
  }, POLLING_INTERVAL);
};

const captureElementsContainingString = (searchString = "_pfand") => {
  const elements = [...document.querySelectorAll('.upcart-item-property')];
  return elements.filter((el) => el.textContent.includes(searchString));
};

const pfMainProductInputDisable = () => {
    const mappedIds = new Set(Object.keys(PFAND_MAP).map(String));
    const rows = document.querySelectorAll('.styles_ProductRow__product__.upcart-product-item');

    rows.forEach((row) => {
        // id 
        let vid =
          row.getAttribute('data-variant-id') ||
          row.id ||
          '';

        if (!mappedIds.has(String(vid))) {
          const digits = (String(vid).match(/\d{6,}/) || [])[0]; // 6+
          if (digits) vid = digits;
        }

        if (mappedIds.has(String(vid))) {
          row.classList.add('disable-input-for-pf');
        } else {
          row.classList.remove('disable-input-for-pf');
        }
    });
};


function refreshCartOnce() {
  if (!window.__pfandRefreshLock) {
    window.__pfandRefreshLock = true;
    window.__pfandSuppressUntil = Date.now() + 2000; // 2s TTL
    typeof window.upcartRefreshCart === 'function' && window.upcartRefreshCart();
    setTimeout(() => {
      window.__pfandRefreshLock = false;
      window.__suppressPfandSync = false;
    }, 2200);
  }
}

async function getFreshCart() {
  try {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('cart.js fetch failed');
    return await res.json();
  } catch (e) {
    console.warn('getFreshCart() failed, falling back to event cart:', e);
    return null;
  }
}

/***********************
 * ATC + UPDATE HELPERS
 ***********************/
const pfandAtcFn = (secondProductVariantId) => {
  window.addEventListener('aftersell-upcart:public-events:added-to-cart', function () {
    window.__suppressPfandSync = true;
    const quantityEl = document.getElementById('pfand-quantity');
    const quantity = quantityEl ? quantityEl.value : 1;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: secondProductVariantId, quantity }]
      }),
    })
      .then((response) => response.json())
      .then(() => {
        setTimeout(() => { window.__suppressPfandSync = false; }, 2000);
      })
      .catch((error) => {
        console.error('Error adding second product:', error);
        setTimeout(() => { window.__suppressPfandSync = false; }, 800);
      });
  });
};

const pfandUpdateFn = (secondProductVariantId) => {
  window.addEventListener('aftersell-upcart:public-events:cart-updated', function (event) {
    setTimeout(async () => {
      if (window.__suppressPfandSync || window.__pfandBusy) return;

      const fresh = await getFreshCart().catch(() => null);
      const cart  = fresh || event.detail?.cart || {};
      const items = cart.items || [];

      const markId = String(PFAND_VARIANT_ID ?? secondProductVariantId);

      const markedBase = items.filter(i => i?.properties?._pfand == markId);
      let desiredQty = 0;

      if (markedBase.length) {
        markedBase.forEach(i => {
          const mult =
            parseInt(i?.properties?._pfand_quantity) ||
            getPfandMultiplierFor(getVarId(i));
          if (mult > 0) desiredQty += (i.quantity || 0) * mult;
        });
      } else {
        items.forEach(i => {
          const mult = getPfandMultiplierFor(getVarId(i));
          if (mult > 0) desiredQty += (i.quantity || 0) * mult;
        });
      }

      desiredQty = Math.max(0, Number.isFinite(desiredQty) ? Math.round(desiredQty) : 0);

      const secondProduct = items.find(i => getVarId(i) === String(markId));
      const currentQty    = secondProduct ? secondProduct.quantity : 0;

      if (currentQty === desiredQty) return;
      if (desiredQty === 0 && !secondProduct) return;

      window.__suppressPfandSync = true;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [markId]: desiredQty } }),
      }).then(r => r.json()).catch(e => console.error('pfandUpdateFn error:', e));

      refreshCartOnce();
    }, 0);
  });
};

const pfandPropertiesUpdateFn = () => {
  const meta = document.querySelector('.product-section .product-single__meta');
  if (!meta) return;
  meta.addEventListener('change', () => {
    const varSelect = document.querySelector('.product-single__variants');
    if (!varSelect) return;
    const currentVariantId = varSelect.value;
    if (typeof pfandVariants === 'undefined') return; // external source
    const matchedPfand = pfandVariants.find((v) => v.id == currentVariantId);
    if (matchedPfand) {
      const pfQtyEl = document.getElementById('pfand-quantity');
      if (pfQtyEl) pfQtyEl.value = matchedPfand.pfand_quantity;
    }
  });
};

/***********************
 * PFAND CORE FLOW
 ***********************/
const UpsellPfand = async (cart) => {
  const now = Date.now();
  if (now - (window.__pfandDebounceTS || 0) < 300) return;
  if (window.__pfandBusy || window.__suppressPfandSync) return;
  window.__pfandDebounceTS = now;

  window.__pfandBusy = true;
  window.__suppressPfandSync = true;

  try {
    const items = cart?.items || [];

    // base lines  mapping
    const baseLines = items.filter((i) => getPfandMultiplierFor(getVarId(i)) > 0);

    // pfand line (if in cart)
    const pfandLine = items.find((i) => getVarId(i) === String(PFAND_VARIANT_ID));

    // ---- desired pfand qty ----
    const markedBaseLines = items.filter(
      (i) => i?.properties?._pfand == String(PFAND_VARIANT_ID)
    );

    let desiredPfandQty = 0;

    if (markedBaseLines.length) {
      markedBaseLines.forEach((i) => {
        const mult =
          parseInt(i?.properties?._pfand_quantity) ||
          getPfandMultiplierFor(getVarId(i)); // if missing for mapping
        if (mult > 0) desiredPfandQty += (i.quantity || 0) * mult;
      });
    } else {
      // sum(baseQty * multiplier)
      baseLines.forEach((i) => {
        const mult = getPfandMultiplierFor(getVarId(i));
        desiredPfandQty += (i.quantity || 0) * mult;
      });
    }

    // out from here
    if (desiredPfandQty <= 0 && !pfandLine) {
      window.__pfandBusy = false;
      window.__suppressPfandSync = false;
      return;
    }

    // ---- base lines properties 
    const ops = [];

    baseLines.forEach((line) => {
      const lineKey = line.lineItemKey || line.key; // UpCart/Shopify
      const needMark =
        lineKey &&
        !(line.properties && line.properties._pfand && line.properties._pfand_quantity);

      if (needMark) {
        const mult = getPfandMultiplierFor(getVarId(line));
        ops.push(
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: lineKey,
              quantity: line.quantity,
              properties: {
                _pfand: String(PFAND_VARIANT_ID),
                _pfand_quantity: String(mult),
              },
            }),
          }).then((r) => r.json())
        );
      }
    });

    // ---- pfand variant qty enforce ----
    const currentPfandQty = pfandLine ? pfandLine.quantity : 0;
    // normalize desired
    desiredPfandQty = Math.max(0, Number.isFinite(desiredPfandQty) ? Math.round(desiredPfandQty) : 0);

    if (currentPfandQty !== desiredPfandQty) {
      ops.push(
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [PFAND_VARIANT_ID]: desiredPfandQty } }),
        }).then((r) => r.json())
      );
    }

    if (ops.length === 0) {
      window.__pfandBusy = false;
      window.__suppressPfandSync = false;
      return;
    }

    await Promise.allSettled(ops);
    // one-time refresh
    refreshCartOnce();
  } catch (e) {
    console.error('UpsellPfand error:', e);
  } finally {
    // lock clear only in handler
    window.__pfandBusy = false;
  }
};

if (pfandInput && pfandInputQuantity) {
  pfandAtcFn(pfandInput.value);      // uses second product variant id
  pfandUpdateFn(pfandInput.value);   // keeps pfand qty in sync across base lines
  pfandPropertiesUpdateFn();
}

window.addEventListener('aftersell-upcart:public-events:cart-opened', () => {
  pfMainProductInputDisable();
});

window.addEventListener('aftersell-upcart:public-events:cart-updated', (event) => {
  (async () => {
    // our own refresh/update --> consume
    const inTTL = Date.now() < (window.__pfandSuppressUntil || 0);
    if (window.__pfandRefreshLock || window.__suppressPfandSync || inTTL) {
      window.__pfandRefreshLock = false;
      window.__suppressPfandSync = false;
      pfMainProductInputDisable?.();
      return;
    }

    // stale data
    const fresh = await getFreshCart();
    const cart = fresh || event.detail.cart;

    await UpsellPfand(cart);           
    try { pfMainProductInputDisable?.(); } catch (_) {} // UI
  })();
});

/***********************
 * CART PAGE REDIRECT + AUTO OPENCART
 ***********************/
(function () {
  // Helper to wait until a condition is true
  function waitUntil(conditionFn, callback, checkInterval = 50, timeout = 10000) {
    const start = Date.now();
    const interval = setInterval(() => {
      if (conditionFn()) {
        clearInterval(interval);
        callback();
      } else if (Date.now() - start > timeout) {
        clearInterval(interval);
        console.warn('waitUntil: Timeout reached without condition met.');
      }
    }, checkInterval);
  }

  // If on /cart page → redirect to homepage with query flag
  if (window.location.pathname === '/cart') {
    if (!window.location.search.includes('openCart=1')) {
      window.location.href = '/?openCart=1';
    }
    return; // Stop executing rest of script on /cart
  }

  // If query flag present → wait for UpCart and open it
  const params = new URLSearchParams(window.location.search);
  if (params.get('openCart') === '1') {
    waitUntil(
      () => typeof window.upcartOpenCart === 'function',
      () => {
        window.upcartOpenCart();
        // Clean URL after opening
        if (window.history && window.history.replaceState) {
          const cleanUrl = window.location.origin + window.location.pathname;
          window.history.replaceState({}, document.title, cleanUrl);
        }
      }
    );
  }
})();
